import React, { useEffect, useState } from "react";
import Open from "../../assets/images/Open.png";
import Close from "../../assets/images/closed.png";
import { Link } from "react-router-dom";
import {  useSelector } from 'react-redux';
import { Card } from "../common/GlobalElements/Card";
import { Heading5 } from "../common/GlobalElements/Typography";
function ReRegistrationList(props) {
  const { registration,disabled = false } = props;
  const [filesNeeded, setFilesNeeded] = useState(false);
  const [marksPending, setMarksPending] = useState(false);
  const user = useSelector((state) => state.user);
  useEffect(() => {
    if (registration?.filesNeeded) {
      // check if filesNeeded contains a entry where active == 1 and uploaded == 0
      const filesNeededTemp = registration?.filesNeeded.some(
        (file) => file.active == 1
      );
      let per = registration?.per;
      let processedTooFar = (per == "80%" || per == "90%" || per == "95%" || per == "100%") ? true : false;
      setFilesNeeded(filesNeededTemp && !processedTooFar);
    }
    if(registration?.per){
      if(registration?.per === -1){
        setMarksPending(true);
      }
    }
  }, [registration]);
  return (
    <>
      <li>
        <Card 
          gap={"10px"}
          className={`re-registration-bx-card ${(disabled || marksPending) ? 'block-disable' : ''}`}
          $position="relative"
        >
          {!disabled && !marksPending ? <Link
            title={registration?.academy}
            to={user.status == 'Results Witheld' ? '/ResultWithheld' : "/reregistrationSchool/" + registration?.id + "/" + registration?.qualification_higher_enrolled}
            className="re-registration-link-redirect"
          ></Link> : null}
          <div className="icon">SE</div>
          <Heading5>
            {registration?.academy}
            <br /> Intake {registration?.intake_number},{" "}
            {registration?.intake_year}
          </Heading5>
          {registration?.reg_status == "Closed" ? (
            <p className="flex items-center gap-2 justify-center">
              <i className="">
                <img src={Close} />
              </i>
              CLOSED
            </p>
          ) : (
            <p className="flex items-center gap-2 justify-center">
              <i className="">
                <img src={Open} />
              </i>
              OPEN
            </p>
          )}

          {(registration?.registrationStatus || registration?.per )? (
            <span className={`${registration?.statusColor || "red"}`}>
              {registration?.per == "-1%" ? <i className="fal fa-exclamation-circle"></i> :<i className="fal fa-user-check"></i>} {registration?.status}
            </span>
          ) : (
            <span className={`${registration?.statusColor || "red"}`}>
              {registration?.per == "-1%" ? <i className="fal fa-exclamation-circle"></i> :<i className="fal fa-user-times"></i>} Not Registered
            </span>
          )}

          <p>
            <i className="fal fa-calendar-days"></i>
            {registration?.start_date} to {registration?.end_date}
          </p>
        </Card>
      </li>
    </>
  );
}

export default ReRegistrationList;
